<icc-list [searchable]="true" [items]="drives"
          [itemTemplate]="'itemImgTitle'"
          itemImgHeight="medium"
          (showInfo)="showInfo($event)"
          (select)="selectDrive($event)"></icc-list>
